import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-09NC4CK120';

/**
 * Composant invisible qui track les changements de page (pageviews)
 * pour Google Analytics 4 lors de la navigation React Router.
 * 
 * Le script gtag.js est chargé dans index.html.
 */
export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title,
        anonymize_ip: true,
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      });
    }
  }, [location]);

  return null;
};

/**
 * Helper pour tracker des événements personnalisés (clics CTA, soumission formulaire, etc.)
 * 
 * Exemples :
 *   trackEvent('click', { event_category: 'CTA', event_label: 'Prendre RDV - Hero' });
 *   trackEvent('form_submit', { event_category: 'Contact', event_label: 'Formulaire contact' });
 */
export const trackEvent = (action, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};
